"use strict";
/****************************************************
 * Audit Information Platform Component
 * 多选参照项基类 (该组件由于目前没有应用场景，所以没有完全实现)
 * 2020-08
 * Sunny <tufpsj@yonyou.com>
 ****************************************************/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
//----- Global ------
var React = require("react");
//----- AIP ------
var RefItem_1 = require("./RefItem");
/**
 * 单选参照组件
 * [暂时没有实际使用]
 */
var RadioRef = /** @class */ (function (_super) {
    __extends(RadioRef, _super);
    function RadioRef() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            options: [],
            value: '',
        };
        _this.hasRefItems = function () {
            return true; // 暂时没有实现，该组件目前不可用
        };
        _this.validConditions = function () {
            return false; // 暂时没有实现，该组件目前不可用
        };
        /**
         * 转换数据为{label: value}的数组
         * @function
         * @param {any[]} arr 原始数组
         * @returns {ItemInfo[]} 转换后的数组
         */
        _this._prepareData = function (arr) {
            var datas = [];
            arr.forEach(function (element) {
                var item = {};
                try {
                    var label = element[_this.props.displayfield];
                    var value = element[_this.props.valuefield];
                    item['label'] = label;
                    item['value'] = value;
                    item['name'] = _this.props.name + 'inner';
                    datas.push(item);
                }
                catch (e) { }
            });
            return datas;
        };
        /**
         * 远程请求数据
         * @function
         * @param {StringStringMap} params 请求的参数
         * @param {string} defaultValue 默认值
         */
        _this._loadData = function (params, defaultValue) {
            if (_this.props.options)
                return; // 如果是直接显示的，就不load数据了
            if (_this.validConditions()) {
                // not implement
            }
        };
        /**
         * 重置值 **override**
         * @function
         */
        _this.clear = function () {
            _this.setState({ defaultValue: [], value: '' }, function () { });
        };
        /**
         * 获取值， **override**
         * @function
         * @returns {string}
         */
        _this.getValue = function () {
            return _this.state.value;
        };
        return _this;
    }
    RadioRef.prototype.componentDidMount = function () {
        if (!this.props.options || this.props.options.length === 0) { // 如果没有options，就从网络拉取数据
            if (this.hasRefItems()) { // 如果有依赖，先不处理
                // igonre
            }
            else {
                this._loadData({});
            }
        }
        else { // 有options就直接显示
            this.setState({ options: this._prepareData(this.props.options || []) }, function () { });
        }
    };
    RadioRef.prototype.render = function () {
        return (React.createElement(React.Fragment, null, this.state.options.map(function (item) {
            // return <Radio key={item.value} ref={item.label} value={item.value} onChange={this.onChange}>{item.label}</Radio>
            return (React.createElement("label", { style: { position: "relative", lineHeight: 18 } },
                React.createElement("input", { type: "radio", value: item.value, name: item.name, style: {
                        position: "absolute", zIndex: 3, cursor: "pointer",
                        top: 1, boxSizing: "border-box", padding: 0, height: "100%"
                    } }),
                React.createElement("label", { style: { height: '26px', fontSize: "12px", cursor: "Pointer", display: "inline-block", position: "relative", paddingLeft: "18px", marginRight: "16px", color: "#212121" } }, item.label)));
        })));
    };
    return RadioRef;
}(RefItem_1.default));
exports.default = RadioRef;
